<template>
  <vs-popup class="preview_geo" :title="title" :active.sync="addNewDataLocal">
    <GeofeceData
      @deleteGeo="deleteGeo"
      @editGeo="clickEdit"
      :dataEdit="dataEdit"
      :dataCoordinate="dataCoor"
      :geoType="geoType"
      :geoName="geoName"></GeofeceData>
  </vs-popup>
</template>

<script>
import * as REPO from '../../repository/index'
import GeofeceData from './POIViewData.vue'

export default {
  props: {
    addNewData: {
      type: Boolean,
      required: true,
    },
    title: String,
    geoType: String,
    allData: Array,
    dataCoordinate: Array,
    alertData: Array,
    geoName: String,
    fleetGroupData: Array,
    editMode: Boolean,
    dataEdit: Object,
  },
  components: {
    GeofeceData,
  },
  watch: {
    editMode(val) {
      if (val) {
        // this.s_alert = this.dataEdit.alert_id;
        // this.calculateFleetEdit(this.s_alert);
        // this.fleetGroup = this.dataEdit.fleet_group_id;
        //
      } else {
        //
      }
    },
    s_alert(val) {
      this.calculateFleet(val)
    },
  },
  mounted() {
    //
  },
  computed: {
    addNewDataLocal: {
      get() {
        if (this.addNewData) {
          this.dataCoor = this.dataCoordinate
        } else {
          this.dataCoor = []
        }
        return JSON.parse(this.addNewData)
      },
      set(val) {
        if (!val) {
          //
          this.$emit('closeModal')
        }
      },
    },
    validateForm() {
      return !this.errors.any() && this.mailTo != ''
    },
  },
  data() {
    return {
      alert_array: [],
      fleet_array: [],
      s_alert: '',
      dataCoor: [],
      fleetGroup: '',
    }
  },
  methods: {
    deleteGeo() {
      this.$emit('deleteModal')
    },
    clickEdit() {
      //
      this.$emit('closeModal')
    },
  },
}
</script>
<style>
.preview_geo > .vs-popup > .vs-popup--content {
  width: 100%;
  padding: 0 !important;
  margin: 0 !important;
}
</style>
